"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MidCore = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var consts = _interopRequireWildcard(require("./constants"));

var _immutable = require("immutable");

var _stateMachine = require("./state-machine");

var _timer = require("./timer");

var _drivers = _interopRequireDefault(require("./drivers"));

var _errors = require("./errors");

var _support = require("./support");

/* global sessionStorage, localStorage */

/**
 * Private implementation for McKinsey ID
 */
var MidCore = /*#__PURE__*/function () {
  /**
   * Create a new MidCore instance
   *
   * @param {Mid} mid - the original Mid object
   * @param {MidConfig} config - the Mid configuration
   */
  function MidCore(mid, config) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, MidCore);
    this.setLoginInfo = this.setLoginInfo.bind(this);
    this.setTenant = this.setTenant.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.setTokens = this.setTokens.bind(this);
    this.isAuthed = this.isAuthed.bind(this);
    this.login = this.login.bind(this);
    this.refresh = this.refresh.bind(this);
    this.logout = this.logout.bind(this);
    this.driverFor = this.driverFor.bind(this);
    this.refreshLatch = null;
    (0, _timer.registerActivityHandler)();
    this.redirectUrl = new URL(config.redirectUrl.toString());
    this.logoutRedirectUrl = config.logoutRedirectUrl;
    this.loginWidget = config.loginWidget;
    this.drivers = {};
    Object.entries(config.drivers).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      _this.drivers[k.toLowerCase()] = v;
    });
    this.emailToLoginInfo = config.emailToLoginInfo;
    this.tenantListing = config.tenantListing;
    this.scopes = config.scopes || [];
    this.errors = (0, _errors.makeErrors)(config.errors);
    this.timer = null;
    this.state = (0, _immutable.Map)().set(_stateMachine.PHASE, _stateMachine.ST.START).set(_stateMachine.DATA, null).set(_stateMachine.MID, this);

    this.onLoginResolve = function () {
      if (_this.loginResolvers.length > 0) {
        // store off the current list of login resolvers just in case another one
        // gets added while we are resolving
        var lrs = _this.loginResolvers; // re-initialize a new list of login resolvers

        _this.loginResolvers = []; // resolve

        try {
          lrs.forEach(function (lr) {
            return lr(_this);
          });
        } catch (err) {
          console.error(_this.errors.ERR_UNHANDLED('Unhandled error during login resolution'));

          _this.logout();
        }
      }
    };

    this.loginResolvers = [(0, _support.wrapLoginResolver)((0, _timer.loginResolver)(this, consts.INACTIVITY_TIMEOUT_MS, consts.EXP_TIME_BUFFER_MS))];

    if (config.landingFn) {
      this.landingFn = config.landingFn;
    }

    if (config.setCookie) {
      this.setCookie = config.setCookie;
    }

    if (config.mode) {
      this.mode = config.mode;
    }

    var loginInfo = (0, _support.getLoginInfo)();

    if (this.redirectUrl.pathname === window.location.pathname) {
      // Landing on MID from a redirect from the IdP
      this.redirectLanding(loginInfo);
    } else {
      if (loginInfo) {
        // attempt to SSO
        try {
          var tenant = (0, _support.getTenant)();

          if (tenant) {
            var tenantInfo = (0, _support.tenantToLoginInfo)(tenant);
            var driver = (0, _drivers["default"])(this, tenantInfo);
            this.sso = driver.attemptSSO(this, tenantInfo);
          } else {
            var _driver = (0, _drivers["default"])(this, loginInfo);

            this.sso = _driver.attemptSSO(this, loginInfo);
          }

          return;
        } catch (err) {
          // login information was bad - remove it
          (0, _support.destroyStorage)(this);
        }

        this.sso = Promise.resolve();
        this.state = this.loginWidget.transition(this.state);
      }
    }
  }
  /**
   * Returns the driver registered under "driverName" or null if no driver by that name is found
   * @param {string} driverName - the driver to look for a registry entry for. Canonicalizes the name to lowercase
   * @return {AuthDriver|null} an authDriver or null
   */


  (0, _createClass2["default"])(MidCore, [{
    key: "driverFor",
    value: function driverFor(driverName) {
      var driver = this.drivers[driverName.toLowerCase()];

      if (!driver) {
        return null;
      } else {
        return driver;
      }
    }
    /**
     * Completes the login process. Makes sure the various required data is stored correctly.
     * @return {void}
     */

  }, {
    key: "onComplete",
    value: function () {
      var _onComplete2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var loginInfo, tenant, accessToken, idToken;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                loginInfo = (0, _support.getLoginInfo)();
                tenant = (0, _support.getTenant)();
                accessToken = this.accessToken();
                idToken = this.idToken();
                (0, _support.onComplete)(this, loginInfo, idToken, accessToken, tenant);
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                _context.next = 12;
                return (0, _support.destroyStorage)(this);

              case 12:
                console.error(this.errors.ERR_UNHANDLED('Misconfiguration in the tenant/token/login info flow. Abandoning login'));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function onComplete() {
        return _onComplete2.apply(this, arguments);
      }

      return onComplete;
    }()
    /**
     * Handle the redirectUri landing
     * @param {LoginInfo} loginInfo - the login configuration
     * @return {void} nothing
     */

  }, {
    key: "redirectLanding",
    value: function redirectLanding(loginInfo) {
      try {
        if (!loginInfo) return;
        (0, _support.onLanding)(this, loginInfo);
      } catch (err) {
        console.error(this.errors.ERR_UNHANDLED('Error encountered while handling token landing'), err);
      }
    }
    /**
     * Sets the tokens for this mid instance
     * @param {string} idToken the ID Token from an OIDC IdP
     * @param {string} accessToken the Access Token from an OIDC IdP
     * @return {MidCore} the mid instance
     */

  }, {
    key: "setTokens",
    value: function () {
      var _setTokens = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(idToken, accessToken) {
        var tenant;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sessionStorage.setItem(consts.MID_ID_TOKEN_KEY, idToken);
                sessionStorage.setItem(consts.MID_ACCESS_TOKEN_KEY, accessToken);
                tenant = (0, _support.getTenant)();

                if (!(this.setCookie && tenant)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return this.setCookie({
                  tenant: tenant.tenantId,
                  accessToken: accessToken
                });

              case 6:
                return _context2.abrupt("return", this);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setTokens(_x, _x2) {
        return _setTokens.apply(this, arguments);
      }

      return setTokens;
    }()
    /**
     * Sets the browser state for the tenant config provided
     *
     * @param {Tenant} tenantConfig - the tenant configuration
     * @return {MidCore} the mid instance
     */

  }, {
    key: "setTenant",
    value: function setTenant(tenantConfig) {
      var tenantJson = JSON.stringify(tenantConfig);
      sessionStorage.setItem(consts.MID_TENANT_KEY, tenantJson);
      return this;
    }
    /**
     * Set the appropriate login configuration for the provided
     * information
     *
     * @param {LoginInfo} loginInfo - the login information
     * @return {MidCore} this mid instance
     */

  }, {
    key: "setLoginInfo",
    value: function setLoginInfo(loginInfo) {
      var loginInfoJson = JSON.stringify(loginInfo);
      localStorage.setItem(consts.MID_LOGIN_KEY, loginInfoJson);
      return this;
    }
    /**
     * Is the user authenticated?
     *
     * @return {Promise<boolean>} - is this user logged in (after checking sso)
     */

  }, {
    key: "isAuthed",
    value: function () {
      var _isAuthed = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.sso;

              case 2:
                return _context3.abrupt("return", !!(0, _support.getAccessToken)() && !!(0, _support.getTenant)());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function isAuthed() {
        return _isAuthed.apply(this, arguments);
      }

      return isAuthed;
    }()
    /**
     * Attempt to log the user in.
     *
     * @return {Promise<void>} - void
     */

  }, {
    key: "login",
    value: function () {
      var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var core, isAuthed;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                core = this;
                _context4.next = 3;
                return this.isAuthed();

              case 3:
                isAuthed = _context4.sent;
                return _context4.abrupt("return", new Promise(function (resolve) {
                  core.loginResolvers.push((0, _support.wrapLoginResolver)(resolve));

                  if (isAuthed) {
                    core.onLoginResolve();
                  }
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }()
    /**
     * Attempt to refresh the user's tokens, the driver is responsible for destroying the
     * login information if there is any problem refreshing.
     *
     * @return {Promise<void>} - suspends until the refresh is complete
     */

  }, {
    key: "refresh",
    value: function () {
      var _refresh = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var tenant, loginInfo;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.refreshLatch) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 3;
                return this.refreshLatch;

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
                tenant = (0, _support.getTenant)();

                if (!tenant) {
                  _context5.next = 20;
                  break;
                }

                _context5.prev = 6;
                loginInfo = (0, _support.tenantToLoginInfo)(tenant);
                this.refreshLatch = (0, _drivers["default"])(this, loginInfo).refresh(this, this.redirectUrl, this.scopes, loginInfo);
                _context5.next = 11;
                return this.refreshLatch;

              case 11:
                this.refreshLatch = null;
                _context5.next = 20;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](6);
                // it's likely the refresh didn't happen. a logout should immediately follow.
                console.error(_context5.t0);
                _context5.next = 19;
                return this.logout();

              case 19:
                this.refreshLatch = null;

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 14]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
    /**
     * Log the user out
     *
     * @return {Promise<void>} - void
     */

  }, {
    key: "logout",
    value: function () {
      var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var tenant, loginInfo;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                tenant = (0, _support.getTenant)();

                if (!tenant) {
                  _context6.next = 6;
                  break;
                }

                loginInfo = (0, _support.tenantToLoginInfo)(tenant);
                _context6.next = 6;
                return (0, _drivers["default"])(this, loginInfo).logout(this, loginInfo);

              case 6:
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                console.error('error encountered trying to log out from idp', _context6.t0);

              case 11:
                _context6.prev = 11;

                // stop any timer
                if (this.timer) {
                  clearInterval(this.timer);
                }

                _context6.next = 15;
                return (0, _support.destroyStorage)(this);

              case 15:
                window.location = this.logoutRedirectUrl;
                return _context6.finish(11);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8, 11, 17]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
    /**
     * Initiate the redirect login flow
     *
     * @param {string} email - the user's email
     * @param {LoginInfo} loginInfo - the user's login info
     * @return {Promise<*>} - void
     */

  }, {
    key: "redirectLogin",
    value: function () {
      var _redirectLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(email, loginInfo) {
        var driver;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (loginInfo) {
                  _context7.next = 2;
                  break;
                }

                throw new Error(this.errors.ERR_MISCONFIGURATION('Missing Login Information'));

              case 2:
                _context7.prev = 2;
                driver = (0, _drivers["default"])(this, loginInfo);
                _context7.next = 6;
                return driver.redirectLogin(this, this.redirectUrl, null, email, this.scopes, loginInfo);

              case 6:
                return _context7.abrupt("return", _context7.sent);

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);
                _context7.next = 13;
                return (0, _support.destroyStorage)(this);

              case 13:
                throw _context7.t0;

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 9]]);
      }));

      function redirectLogin(_x3, _x4) {
        return _redirectLogin.apply(this, arguments);
      }

      return redirectLogin;
    }()
    /**
     * Initiate the hosted login flow.
     *
     * @param {string} email - the user's email
     * @param {string} password - the password
     * @param {Tenant} tenant - the tenant
     * @return {Promise<*>} - void
     */

  }, {
    key: "hostedLogin",
    value: function () {
      var _hostedLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(email, password, tenant) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                throw new Error('Currently Unsupported');

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function hostedLogin(_x5, _x6, _x7) {
        return _hostedLogin.apply(this, arguments);
      }

      return hostedLogin;
    }()
    /**
     * Perform the hosted "forgot password" flow.
     *
     * @param {MidCore} mid - the mid core instance
     * @param {string} email - the user's email
     * @param {Tenant} tenant - the tenant to recover the password for
     * @return {Promise<void>} - void
     */

  }, {
    key: "hostedForgotPassword",
    value: function () {
      var _hostedForgotPassword = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(mid, email, tenant) {
        var driver;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                driver = (0, _drivers["default"])(mid, (0, _support.tenantToLoginInfo)(tenant));
                _context9.prev = 1;
                _context9.next = 4;
                return driver.hostedForgotPassword(email, this.redirectUrl, tenant);

              case 4:
                _context9.next = 9;
                break;

              case 6:
                _context9.prev = 6;
                _context9.t0 = _context9["catch"](1);
                throw new Error(this.errors.ERR_UNHANDLED(_context9.t0));

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 6]]);
      }));

      function hostedForgotPassword(_x8, _x9, _x10) {
        return _hostedForgotPassword.apply(this, arguments);
      }

      return hostedForgotPassword;
    }()
    /**
     * @return {*} the access Token used to authenticate against a remote api
     */

  }, {
    key: "accessToken",
    value: function accessToken() {
      return (0, _support.getAccessToken)();
    }
    /**
     * @return {*} the id Token used to hold the authenticated party's identity
     */

  }, {
    key: "idToken",
    value: function idToken() {
      return (0, _support.getIdToken)();
    }
    /**
     * Get user info.
     *
     * @return {Promise<UserInfo>} - UserInfo
     */

  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        var user, tenant, driver, _user;

        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                user = localStorage.getItem(consts.MID_USER_INFO_KEY);

                if (!user) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("return", JSON.parse(user));

              case 4:
                tenant = (0, _support.getTenant)();

                if (!tenant) {
                  _context10.next = 12;
                  break;
                }

                driver = (0, _drivers["default"])(this, (0, _support.tenantToLoginInfo)(tenant));
                _context10.next = 9;
                return driver.userInfo(this, tenant);

              case 9:
                _user = _context10.sent;

                if (_user) {
                  localStorage.setItem(consts.MID_USER_INFO_KEY, JSON.stringify(_user));
                }

                return _context10.abrupt("return", _user);

              case 12:
                _context10.next = 17;
                break;

              case 14:
                _context10.prev = 14;
                _context10.t0 = _context10["catch"](0);
                console.error(Error(this.errors.ERR_UNHANDLED(_context10.t0)));

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 14]]);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
  }]);
  return MidCore;
}();

exports.MidCore = MidCore;